var map = {
  "./ar_SA.json": [
    "59487",
    [
      8210
    ]
  ],
  "./uk.json": [
    "17781",
    [
      6166
    ]
  ],
  "./bg.json": [
    "75986",
    [
      951
    ]
  ],
  "./fi.json": [
    "26336",
    [
      7997
    ]
  ],
  "./sv.json": [
    "64052",
    [
      9901
    ]
  ],
  "./ja.json": [
    "14292",
    [
      5649
    ]
  ],
  "./ar.json": [
    "5302",
    [
      8811
    ]
  ],
  "./sr.json": [
    "7384",
    [
      8345
    ]
  ],
  "./sl.json": [
    "99569",
    [
      4799
    ]
  ],
  "./fr.json": [
    "57413",
    [
      630
    ]
  ],
  "./nb.json": [
    "30157",
    [
      7390
    ]
  ],
  "./zh_HK.json": [
    "96677",
    [
      380
    ]
  ],
  "./sq.json": [
    "12245",
    [
      2682
    ]
  ],
  "./pl.json": [
    "36189",
    [
      3642
    ]
  ],
  "./ro.json": [
    "42330",
    [
      7103
    ]
  ],
  "./hu.json": [
    "1922",
    [
      7219
    ]
  ],
  "./zh_TW.json": [
    "13645",
    [
      3924
    ]
  ],
  "./ca.json": [
    "34229",
    [
      5565
    ]
  ],
  "./de.json": [
    "26030",
    [
      8671
    ]
  ],
  "./vi.json": [
    "1456",
    [
      269
    ]
  ],
  "./tr.json": [
    "38691",
    [
      3624
    ]
  ],
  "./da.json": [
    "78514",
    [
      3995
    ]
  ],
  "./zh_CN.json": [
    "38865",
    [
      8836
    ]
  ],
  "./he.json": [
    "70418",
    [
      1811
    ]
  ],
  "./id.json": [
    "36528",
    [
      4669
    ]
  ],
  "./lv.json": [
    "91703",
    [
      9844
    ]
  ],
  "./es.json": [
    "80605",
    [
      4958
    ]
  ],
  "./ko.json": [
    "71767",
    [
      9028
    ]
  ],
  "./cs.json": [
    "34091",
    [
      3168
    ]
  ],
  "./ms.json": [
    "2357",
    [
      4294
    ]
  ],
  "./pt_BR.json": [
    "37322",
    [
      1049
    ]
  ],
  "./en_ZZ.json": [
    "93487",
    [
      194
    ]
  ],
  "./sk.json": [
    "47667",
    [
      9432
    ]
  ],
  "./nl.json": [
    "39927",
    [
      9736
    ]
  ],
  "./fa.json": [
    "25656",
    [
      5653
    ]
  ],
  "./ru.json": [
    "87584",
    [
      4829
    ]
  ],
  "./it.json": [
    "84448",
    [
      685
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 4807;
module.exports = __rspack_async_context;
